export default "__VITE_ASSET__e49ce2c2__"